import React, { useEffect, useMemo, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";

import Navbar from "./components/pages/components/Navbar";
import ItemPage from "./components/pages/ItemPage";
import Collection from "./components/pages/Collection";
import About from "./components/pages/About";
import Artist from "./components/pages/Artist";
import Hero from "./components/pages/Hero";
import NamePage from "./components/pages/Names";
import ComingSoon from "./components/pages/ComingSoon";
import FAQs from "./components/pages/FAQs";
import ScrollToTop from "./components/pages/components/ScrollToTop";
import Checkout from "./components/pages/Checkout";
import BackgroundSketch from "./components/pages/components/BackgroundSketch";
import { getRandomisedNames, getRandomisedPrints } from "./components/pages/code/helpers";
import Success from "./components/pages/Success";

function Layout({ names, prints, stock }) {
  const location = useLocation();
  const [hideNavbar, setHideNavbar] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [comingSoonMode, setComingSoonMode] = useState(false);

  const showLogo = location.pathname !== "/collections";

  if (comingSoonMode) {
    return <ComingSoon onUnlock={() => setComingSoonMode(false)} />;
  }

  return (
    <>
      <div className="fixed-background">
        <BackgroundSketch />
      </div>

      {/* Navbar container with placeholder height */}
      <div className={`navbar-wrapper ${hideNavbar ? "navbar-hidden" : ""} ${showLogo ? "navbar-set-height" : ""}`}>
        <Navbar showLogo={showLogo} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>

      <Routes>
        <Route path="/" element={<Hero />} />
        <Route
          path="/collections/:collectionName"
          element={
            <Collection
              prints={prints}
              stock={stock}
              setHideNavbar={setHideNavbar}
            />
          }
        />
        <Route path="/collections/:name/:id" element={<ItemPage stock={stock} />} />
        <Route path="/about" element={<About />} />
        <Route path="/artist/:name" element={<Artist />} />
        <Route path="/collections" element={<NamePage names={names} />} />
        <Route path="/FAQs" element={<FAQs />} />
        <Route path="/checkout" element={<Checkout stock={stock} />} />
        <Route path="/cancel" element={<Checkout stock={stock} />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </>
  );
}

function App() {
  const [stockData, setStockData] = useState({});

  // Shuffle names and prints once per app load
  const shuffledNames = useMemo(() => getRandomisedNames(), []);
  const shuffledPrints = useMemo(() => getRandomisedPrints(), []);

  useEffect(() => {
    async function fetchStock() {
      try {
        const res = await fetch("/.netlify/functions/get-stock-supabase"); // your serverless function
        const data = await res.json();
        setStockData(data);
      } catch (err) {
        console.error("Error fetching stock:", err);
      }
    }
    fetchStock();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Layout
        names={shuffledNames}
        prints={shuffledPrints}
        stock={stockData}
      />
    </Router>
  );
}

export default App;